<section class="team-hero-area fixed-height parallaxBg bg-img" data-bg="assets/img/fondo-gerencia.jpg"
    style="background-image: none;"
    data-jarallax-original-styles="background-image: url(assets/img/team/fondo-gerencia.jpg);">
    <div class="container h-100">
        <div class="row team-member-item h-100">
            <div class="col-lg-7 text-center m-auto">
                <div class="about-us-content white mt-70 mt-sm-50">
                    <h2 style="font-size: 35px; margin-bottom: 0px; line-height: 1.4;">
                        <span>Proyecto de Creación del Servicio de </span>
                        <span>Gestión del Riesgo de Desastres </span>
                        <span>del Centro Histórico del Cusco </span>
                    </h2>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="team-area-wrapper bg-offwhite pt-80 pt-md-80 pt-sm-60 pb-40 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/gerencia/fondo-gerencia.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <div class="col-lg-6 text-center">
              <div class="">
                  <h2>¿QUE BUSCA EL PROYECTO?</h2>
                  <p class="m-0" style="font-size: 16px; line-height: 1.9;">
                    Lograr una sociedad resiliente ante el riesgo de desastres, capaz de salvaguardar la vida y conservar las Áreas Históricas de la
                    Ciudad del Cusco, prevenir y reducir nuevos riesgos, mediante la ejecución de sus 5 componentes.
                  </p>
              </div>
          </div>
          <div class="col-lg-6 text-center">
              <div class="speaker-member-wrap" style="margin-top:-20px;">
                <figure class="speaker-thumbnail">
                    <img src="assets/img/arq_mylene.jpg"
                        alt="GERENCIA DEL CENTRO HISTÓRICO"
                        style="width: 300px; display: block; margin: 0 auto;">
                </figure>
                <div class="speaker-info">
                    <h3 style="text-align: center;">ARQ. MYLENE RYLDA ARIZABAL CALDERÓN</h3>
                    <h6 class="designation mb-20" style="text-align: center;">RESIDENTE DEL PROYECTO</h6>

                </div>
            </div>
          </div>
      </div>
  </div>
</section>
<section class="contact-creative-hero">
  <div class="container-fluid p-0">
      <div class="row align-items-center no-gutters">
          <div class="col-md-12">
            <img src="assets/img/gerencia/gerencia.jpg" alt="Girl in a jacket" width="100%" height="800">
          </div>
      </div>
  </div>
</section>

<div class="freelancer-service-area bg-offwhite pt-120 pt-md-80 pt-sm-60 pb-120 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-componentes.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <div class="section-title-wrap layout--3">
          <h2>COMPONENTES DEL TRABAJO DEL PROYECTO</h2>
        </div>
      </div>
    </div>
    <div class="row mtn-30">
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-laptop" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">Componente I</h3>
            <p>
                
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-film" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">Componente Social</h3>
            <p>Se realizó el registro de más de 71 expresiones culturales con la participación de diferentes actores
              sociales, teniendo como resultado entrevistas a
              profundidad que nos permiten conocer sus actividades
              mediante la web y la publicación del libro:
              “El centro del Cusco: Morada de historia y cultura viva” los saberes y conocimientos de los actores
              sociales del Centro Histórico del Cusco. Así mismo
              se genero la producción de videos, fotografías y narraciones de las mismas.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-check-square-o" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">Componente de Verificación</h3>
            <p>Se cumplió con la actividad que se refiere a la Verificación y contrastación de Fichas impresas y
              digitales de catalogación en un total 14,256 FICHAS
              (Ficha de registro Arquitectura, Ficha de registro fotográfico de Arquitectura, Ficha de registro
              Arqueológico, Ficha de registro fotográfico de Arqueología,
              Ficha de registro Histórico, Ficha de registro legal, planos y descripciones de ambientes urbanos) de
              acuerdo a la catalogación de inmuebles urbanos, religiosos
              y ambientes urbanos del centro histórico del Cusco.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-edit" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">componente de Catalogación</h3>
            <p>Se cumplió con la elaboración de 50 fichas de catalogación de Inmuebles no Catalogados ANC, priorizando
              la catalogación de predios en el siguiente orden:
              declarados monumentos, con valor patrimonial, valor contextual, algún elemento patrimonial; los cuales se
              ubicaron en los Sectores de Gestión SG-0I Núcleo 5
              predios, SG-02 San Cristóbal 7 predios, SG-03 Santo Domingo 3 predios, SG-04 San Blas 11 predios, SG-05
              Santa Ana 2 predios, SG-06 San Pedro 10 predios, SG-07
              Pumacchupan 11 predios y SG-08 1 predio.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


